module.exports = __WEBPACK_EXTERNAL_MODULE_534__;


//////////////////
// WEBPACK FOOTER
// external "weaDoc"
// module id = 534
// module chunks = 1